/* this file is called once all page data and omniture tracking has loaded as to not interfere with the page */
import { addVizurySmartTagScript } from 'vendor/smart_tag';
import { initializeUserSnapView } from 'app/views/store/common/usersnap_helper';
import { FeedbackView } from 'app/views/store/common/usabilla/feedback';
import BazaarVoiceConversionPixelView from 'app/views/store/common/bazaarvoice/conversion';

export function setupThirdParty() {
	initializeUserSnapView();
	// failsafe
	window.BCOM.views = window.BCOM.views || {};

	addVizurySmartTagScript();

	if (!window.dataLayer.isLocalUser && window.dataLayer.environment === 'production') {
		window.BCOM.views.usabillaFeedback = new FeedbackView();
	}

	if (!window.dataLayer.isLocalUser && window.dataLayer.page === 'checkout:ordercomplete') {
		window.BCOM.views.BazaarVoiceConversionPixel = new BazaarVoiceConversionPixelView();
	}
}
